import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box } from '@zillow/constellation-10';

import { ModularListingContext } from '../../../containers/CreateListingPage/context';
import { WizardContext } from '../../Wizard/context';

import { DISPLAY_SERVER_ERROR_AT } from '../../../constants/WizardConstants';

import WizardAlert from '../../WizardAlert';

import PageWizard from '../../Wizard/PageWizard';

import HousingConnectorContentWithFields from './components/HousingConnectorContentWithFields';

import { WizardForm, WizardFormSectionContainer } from '../../../styles/wizard';

const propTypes = {
  onGoToPrevStep: PropTypes.func.isRequired,
  onGoToNextStep: PropTypes.func.isRequired,
  wizardTitle: PropTypes.node.isRequired,
  progressStepper: PropTypes.node.isRequired,
  totalSteps: PropTypes.number.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  showDesktopViewBreakpoint: PropTypes.oneOf(['md' | 'xl' | 'xxl']).isRequired,
};

const defaultProps = {};

const HousingConnector = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  showDesktopViewBreakpoint,
  ...rest
}) => {
  const {
    wizardState: { isFetchingData },
  } = useContext(WizardContext);

  const {
    modularListingState: { serverErrorObj },
  } = useContext(ModularListingContext);

  const [clickedNext, setClickedNext] = useState(false);
  const [clickedBackNext, setClickedBack] = useState(false);

  useEffect(() => {
    const { fieldName } = serverErrorObj;

    if (!fieldName && !isFetchingData) {
      checkNavToStep();
    }
  }, [isFetchingData]);

  const checkNavToStep = () => {
    if (clickedNext) {
      onNextClick();
    }

    if (clickedBackNext) {
      onBackClick();
    }
  };

  const onNextClick = () => {
    if (isFetchingData) {
      setClickedNext(true);
      return;
    }

    onGoToNextStep();
  };

  const onBackClick = () => {
    if (isFetchingData) {
      setClickedBack(true);
      return;
    }

    onGoToPrevStep();
  };

  return (
    <PageWizard
      wizardTitle={wizardTitle}
      progressStepper={progressStepper}
      totalSteps={totalSteps}
      currentStepIndex={currentStepIndex}
      onNextClick={onNextClick}
      onBackClick={onBackClick}
      onExitTriggered={onExitWizard}
      showDesktopViewBreakpoint={showDesktopViewBreakpoint}
      {...rest}
    >
      <div data-testid="HousingConnector">
        <WizardAlert serverErrorObj={serverErrorObj} displayAt={DISPLAY_SERVER_ERROR_AT.PAGE} />

        <Box
          css={{
            display: 'grid',
            gridTemplateColumns: {
              base: 'repeat(6, 1fr)',
              lg: 'repeat(12, 1fr)',
            },
            gap: '400',
          }}
        >
          <Box css={{ gridColumnEnd: { base: 'span 6', lg: 'span 12', xl: 'span 7' } }}>
            {/* cast as div to prevent cannot appear as a descendant of form error */}
            <WizardForm asChild={true} onSubmit={(e) => e.preventDefault()}>
              <div>
                <WizardFormSectionContainer>
                  <HousingConnectorContentWithFields />
                </WizardFormSectionContainer>
              </div>
            </WizardForm>
          </Box>
        </Box>
      </div>
    </PageWizard>
  );
};

HousingConnector.propTypes = propTypes;
HousingConnector.defaultProps = defaultProps;

export default HousingConnector;
